import React, { ReactNode } from "react";
import { Card, Col, Row } from "react-bootstrap";
import MenuItemCard from "../../organisms/MenuItemCard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupsIcon from "@mui/icons-material/Groups";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_SEGURIDAD_ASIGNAR_ROLES,
  RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_SEGURIDAD_ASIGNAR_ROLES) && (
                <CardCol>
                  <MenuItemCard
                    Icono={AdminPanelSettingsIcon}
                    titulo="Asignar roles"
                    descripcion="Designa roles de permisos a grupos de usuarios."
                    ruta={RUTA_SEGURIDAD_ASIGNAR_ROLES}
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={GroupsIcon}
                    titulo="Asociar grupos"
                    descripcion="Asocia usuarios a grupos de permisos."
                    ruta={RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS}
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};

export default CardSection;
